module.exports = __webpack_public_path__ + "img/cat4.c18760b.png";